import { registerMutation } from 'data-fetching-client';
import { updateUserProperties } from '../api/userObject.api';
export const updateUserPropertiesMutation = registerMutation({
  fieldName: 'updateUserProperties',
  args: ['userId', 'userProperties', 'isViewingSelf'],
  fetcher: updateUserProperties
});